var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4Wheeler(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.54,
    height: 17.71,
    viewBox: "0 0 33.54 17.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175878",
    "data-name": "Group 175878",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1293",
    "data-name": "Line 1293",
    x1: 10.467,
    transform: "translate(10.667 13.943)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173280",
    "data-name": "Path 173280",
    d: "M4.552,26.834H1.828A1.328,1.328,0,0,1,.5,25.505V23.128A4.049,4.049,0,0,1,4.548,19.08H26.884a6.151,6.151,0,0,1,6.152,6.152v.789a.817.817,0,0,1-.816.816H28.073",
    transform: "translate(-0.5 -12.891)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173281",
    "data-name": "Path 173281",
    d: "M12.11,6.626l3.123-4.658A3.339,3.339,0,0,1,18,.49h7.391a3.994,3.994,0,0,1,2.883,1.232l4.684,4.9",
    transform: "translate(-8.245 -0.49)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173282",
    "data-name": "Path 173282",
    d: "M28.419,7.577V5.533a.483.483,0,0,0-.483-.483H26.252A2.074,2.074,0,0,0,24.58,5.9L23.562,7.291a.483.483,0,0,0,.39.769H27.94a.483.483,0,0,0,.483-.483Z",
    transform: "translate(-15.821 -3.532)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173283",
    "data-name": "Path 173283",
    d: "M43.43,7.577V5.533a.483.483,0,0,1,.483-.483h2.3a2.069,2.069,0,0,1,1.571.722l1.282,1.492a.484.484,0,0,1-.366.8H43.913a.483.483,0,0,1-.483-.483Z",
    transform: "translate(-29.137 -3.532)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 3.309,
    cy: 3.309,
    rx: 3.309,
    ry: 3.309,
    transform: "translate(4.095 10.091)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 3.189,
    cy: 3.189,
    rx: 3.189,
    ry: 3.189,
    transform: "translate(21.104 10.331)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173284",
    "data-name": "Path 173284",
    d: "M91.233,36.26h1.961a.09.09,0,0,1,.09.09v.809a.149.149,0,0,1-.15.15h-1.9a.425.425,0,0,1-.426-.426v-.2a.425.425,0,0,1,.426-.426Z",
    transform: "translate(-60.743 -24.351)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 1.425,
    cy: 1.425,
    rx: 1.425,
    ry: 1.425,
    transform: "translate(22.869 12.095)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.478,
    cy: 1.478,
    rx: 1.478,
    ry: 1.478,
    transform: "translate(5.926 11.922)",
    fill: "none",
    stroke: "#f47321",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Wheeler);
export default __webpack_public_path__ + "static/media/4_wheeler.4c8631cf49c9e9ba57b8698fc4fc96df.svg";
export { ForwardRef as ReactComponent };